// Is this account a PERSON? (Karan 26/10/2026: "Meeting room needs coordinator
// responsibility but with display option.")
//
// Two kinds of account sign in like a user but are a screen, not a colleague:
//  · a Display-only account (roles only 'Display' — the wallboard iPad's old
//    shape, holding the `display` claim instead of `org`);
//  · a ROOM SCREEN (users/{id}.roomScreen === true, set on Team › Access by an
//    Owner or Director through setRoomScreen). It keeps its permission — the
//    Meeting Room account stays a Coordinator — but it runs the room display.
// Neither is counted as a person: not in meetings, Who's where, approvals,
// reminders, "sheets in", the office board or a task picker. Team still lists
// the account (marked "Room screen") so it can be managed.
//
// THE ONE RULE: every people list in Track goes through isPerson(). The server
// carries the same rule in functions/people.js (test/people.test.mjs keeps the
// two in step). Pure: no imports, so screens, the phone and the tests share it.

/** Roles only 'Display' (the wallboard account's shape). */
export const isDisplayOnly = (u) => !!u && Array.isArray(u.roles) && u.roles.length > 0 && u.roles.every((r) => r === 'Display');

/** Team › Access › Room screen: Yes (only the boolean true counts). */
export const isRoomScreen = (u) => !!u && u.roomScreen === true;

/** A screen on a wall, not a colleague. */
export const isScreen = (u) => isDisplayOnly(u) || isRoomScreen(u);

/** Is this account a person? (Active-ness is the caller's question.) */
export const isPerson = (u) => !!u && !isScreen(u);
